"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "channels-body"
  }, [_c('h2', {
    staticClass: "c-title"
  }, [_vm._v("MIS CANALES Y GRUPOS")]), _c('p', {
    staticClass: "c-subtitle"
  }, [_vm._v("Registra y gestiona los canales externos donde compartes contenido para sincronizar las automatizaciones.")]), _c('div', {
    staticClass: "c-grid"
  }, [_c('div', {
    staticClass: "c-item-card"
  }, [_vm._m(0), _c('div', {
    staticClass: "c-content"
  }, [_c('h4', [_vm._v("Instagram Profile")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.channels.instagram,
      expression: "channels.instagram"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enlace a tu perfil de Instagram"
    },
    domProps: {
      "value": _vm.channels.instagram
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.channels, "instagram", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "c-item-card"
  }, [_vm._m(1), _c('div', {
    staticClass: "c-content"
  }, [_c('h4', [_vm._v("Telegram Channel")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.channels.telegram,
      expression: "channels.telegram"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enlace a tu canal (ej: t.me/tu_canal)"
    },
    domProps: {
      "value": _vm.channels.telegram
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.channels, "telegram", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "c-item-card"
  }, [_vm._m(2), _c('div', {
    staticClass: "c-content"
  }, [_c('h4', [_vm._v("WhatsApp Group")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.channels.whatsapp,
      expression: "channels.whatsapp"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enlace de invitación al grupo"
    },
    domProps: {
      "value": _vm.channels.whatsapp
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.channels, "whatsapp", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "c-item-card"
  }, [_vm._m(3), _c('div', {
    staticClass: "c-content"
  }, [_c('h4', [_vm._v("Twitter Account")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.channels.twitter,
      expression: "channels.twitter"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Nombre de usuario (@tu_user)"
    },
    domProps: {
      "value": _vm.channels.twitter
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.channels, "twitter", $event.target.value);
      }
    }
  })])])]), _c('div', {
    staticClass: "c-actions"
  }, [_c('button', {
    staticClass: "c-save-btn",
    on: {
      "click": _vm.saveChannels
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" REGISTRAR TODOS LOS CANALES ")])])]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "c-icon"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "c-icon"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "c-icon"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "c-icon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]);
}];